(() => {
  if (customElements.get('gg-report-browser')) return;
  customElements.define('gg-report-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.groups = [...this.querySelectorAll('[data-report-group]')];
      this.records = this.groups.flatMap(group => [...group.querySelectorAll('[data-report-link]')].map(link => ({ kind:group.dataset.kind, year:group.dataset.year, month:link.dataset.month, url:link.getAttribute('href'), current:link.getAttribute('aria-current') === 'page' })));
      if (!this.records.length) return;
      this.year = this.querySelector('[data-report-year]'); this.month = this.querySelector('[data-report-month]'); this.go = this.querySelector('[data-report-go]');
      const current = this.records.find(record => record.current);
      this.populateYears(current?.year);
      this.populateMonths(current?.url);
      this.abort = new AbortController();
      this.year.addEventListener('change', () => this.populateMonths(), { signal:this.abort.signal });
      this.month.addEventListener('change', () => this.update(), { signal:this.abort.signal });
      this.querySelector('[data-report-filters]').hidden = false;
      this.ready = true;
    }
    populateYears(preferred) {
      const years = [...new Set(this.records.map(record => record.year))].sort((a,b) => Number(b)-Number(a));
      this.year.replaceChildren(...years.map(year => new Option(year, year)));
      if (years.includes(preferred)) this.year.value = preferred;
    }
    populateMonths(preferred) {
      const records = this.records.filter(record => record.year === this.year.value);
      this.month.replaceChildren(...records.map(record => new Option(record.month, record.url)));
      if (preferred && records.some(record => record.url === preferred)) this.month.value = preferred;
      this.update();
    }
    update() {
      if (this.month.value) this.go.setAttribute('href', this.month.value);
      else this.go.removeAttribute('href');
      if (this.dataset.compact !== 'true') this.groups.forEach(group => { group.hidden = group.dataset.year !== this.year.value; });
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
  });
})();
